import type { DragEvent } from "react"

/** Transparent padding above the pill so the preview sits below the cursor. */
const DRAG_IMAGE_GAP_Y = 16

// eslint-disable-next-line import/prefer-default-export
export const applyMergeTagDragImage = (event: DragEvent<HTMLElement>): void => {
  const source = event.currentTarget

  const dragImage = source.cloneNode(true) as HTMLElement
  dragImage.style.pointerEvents = "none"
  dragImage.style.opacity = "0.92"
  dragImage.style.margin = "0"

  const wrapper = document.createElement("div")
  wrapper.style.cssText = [
    "position: fixed",
    "top: -9999px",
    "left: -9999px",
    "pointer-events: none",
    "display: inline-block",
    `padding-top: ${DRAG_IMAGE_GAP_Y}px`,
  ].join(";")
  wrapper.appendChild(dragImage)
  document.body.appendChild(wrapper)

  const removeDragImage = () => {
    wrapper.remove()
  }
  document.addEventListener("dragend", removeDragImage, { once: true })

  // Cursor at top-left of wrapper (in the top padding); pill appears below.
  event.dataTransfer.setDragImage(wrapper, 0, 0)
}
